module.exports = __webpack_public_path__ + "files/travel_destinations_upload_template.919017f.xlsx";